import React, { useMemo } from 'react';
import { formatNumber as _formatNumber } from 'aegion_common_utilities/lib/format/numeric';
import TransLabel from '../../../common/TransLabel';


/** ****************************
 * HELPERS
 */

const EMPTY_OBJECT = {};
const DEFAULT_HEADER = 'Below -850mv';
const PROP_KEY = 'bcPercentage';

const isDefined = v => v !== undefined && v !== null;

const isNum = v => isDefined(v) && !Number.isNaN(parseFloat(v));

const formatNumber = (v) => {
	if (!isNum(v)) {
		return v;
	}
	if (v === 0) {
		return 0;
	}
	if (v < 1) {
		return _formatNumber(v, { scale: 3 })
	}
	if (v < 10) {
		return _formatNumber(v, { scale: 2 })
	}
	return _formatNumber(v, { scale: 1 })
}

/** ****************************
 * MAIN
 */

const TH = ({ header = DEFAULT_HEADER }) => <TransLabel text={header} abbrv/>;

const TD = ({ item = EMPTY_OBJECT }) => {
	const { value, style } = useMemo(() => {
		const bcPercentage = (item || {})[PROP_KEY];
		if (isDefined(bcPercentage)) {
			return {
				value: `${formatNumber(bcPercentage).toString()}%`,
				style: {
					color: Number.parseFloat(bcPercentage) > 0 ? 'red' : 'inherit'
				}
			};
		}

		return {
			value: '',
			style: {}
		};
	}, [item]);

	return <td style={style}>{value}</td>;
};

const ColNeg850mv = { TH, TD, CSV_PROP: PROP_KEY, DEFAULT_HEADER };

export default ColNeg850mv;
